module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABCElEQVR4AWKgJmg94qAAxIB2zfCEgRAGox3lRrgRHOFGyChucCM5iiM4QpoDA0cptJarl3yk8H4W7qHGmCQJuVNeyJ0kLA9LP/mgVdiFKvAgtf93vVOAPn78uBQ5FZgvpPu/CDyJIixXS2xCE3gyTdiu3Ep8M4QgoRCChEK/nAk2yjYSnZphkfZVNNMQa5zi8VyMnxe9sZ1QEVZDIe+rodR3qTg7ZT2L7I5Fdu/bSqnnC5CdsxwiCUAkHSIZQCRDiRQAkRIifyJEImoZI8NciDApCkTSCJPGwzys8J66SMUHgHIQQIEOoGQKUMRGaivgN3omyEQfkaI9bXhgIEY45g/VxJgTwODZE85RbTJajDaCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map/Green-VeryLow.png
// module id = 965
// module chunks = 1